<template>
  <InputText
    v-if="loading"
    :style="inputProps?.style"
    :class="inputProps?.class"
    loading
  />
  <PrmCalendar
    v-else
    :model-value="modelValue"
    :disabled="disabled || loading"
    :min-date="min"
    :max-date="max"
    :style="inputProps?.style"
    :class="{
      ...normalizeClass(inputProps?.class),
      'p-invalid': invalid || !!errorMessage,
    }"
    :date-format="prmCalendarFormat"
    @update:model-value="onUpdateDate"
  />
</template>

<script setup lang="ts">
import PrmCalendar from '@NitrexGroup/primevue/calendar';

import {
  HTMLProperties, normalizeClass,
} from '../../types/props';
import InputText from '../input-text/input-text.vue';

defineProps<{
  modelValue: Date | undefined,
  disabled?: boolean,
  loading?: boolean,
  invalid?: boolean,
  min?: Date,
  max?: Date,
  errorMessage?: string,
  inputProps?: HTMLProperties,
  prmCalendarFormat?: string,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: Date): void,
}>();

function onUpdateDate(date: Date | Date[] | (Date | null)[] | null | undefined) {
  if (date && !Array.isArray(date)) {
    emit('update:modelValue', new Date(date));
  }
}
</script>
